module.exports = __webpack_public_path__ + "img/values-hand.d635884.jpg";